import { memo } from 'react'

import { Layout } from 'modules/layout'

import AdvancedInstallment from './advancedInstallment'
import ContactUs from './contact-us'
import Hero from './hero'
import TutorialWhatsApp from './tutorialWhatsApp'

const DuplicateBill = memo(() => (
  <Layout hasCTA>
    <Hero />
    <AdvancedInstallment />
    <TutorialWhatsApp />
    <ContactUs />
  </Layout>
))

DuplicateBill.displayName = 'DuplicateBill'

export default DuplicateBill
